import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import GlassCard from "../../components/ui-custom/GlassCard";
import Reveal from "../../components/ui-custom/Reveal";
import { Input } from "../../components/ui/input";
import { Textarea } from "../../components/ui/textarea";
import { Button } from "../../components/ui/button";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const API = `${BACKEND_URL}/api`;

const CATEGORIES = ["Vision", "Business Update", "Milestone", "Team Spotlight", "Other"];

const NewStory = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState(CATEGORIES[0]);
  const [body, setBody] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title.trim() || !body.trim()) {
      setError("Please add a title and some content before publishing.");
      return;
    }
    setSubmitting(true);
    setError("");
    try {
      const res = await axios.post(
        `${API}/employees/stories`,
        { title, body, category },
        { withCredentials: true }
      );
      navigate(`/employees/stories/${res.data.id}`);
    } catch (err) {
      setError("Something went wrong publishing this story. Please try again.");
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-2xl">
      <h2 className="font-display font-semibold text-2xl text-foreground mb-6">Publish a Story</h2>
      <Reveal>
        <GlassCard className="p-7">
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="text-xs font-semibold text-muted-foreground uppercase tracking-wide mb-2 block">
                Title
              </label>
              <Input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="e.g. Sangli plant crosses 500 MVA milestone" />
            </div>

            <div>
              <label className="text-xs font-semibold text-muted-foreground uppercase tracking-wide mb-2 block">
                Category
              </label>
              <select
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                className="flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
              >
                {CATEGORIES.map((c) => (
                  <option key={c} value={c}>
                    {c}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="text-xs font-semibold text-muted-foreground uppercase tracking-wide mb-2 block">
                Story
              </label>
              <Textarea
                value={body}
                onChange={(e) => setBody(e.target.value)}
                placeholder="Share the context, the vision behind it, and why it matters..."
                rows={10}
              />
            </div>

            {error && <p className="text-sm text-destructive">{error}</p>}

            <Button type="submit" className="btn-glow-primary" disabled={submitting}>
              {submitting ? "Publishing…" : "Publish Story"}
            </Button>
          </form>
        </GlassCard>
      </Reveal>
    </div>
  );
};

export default NewStory;
